module.exports = __webpack_public_path__ + "static/media/earth-grid.93407e8b.png";